/* script */

import { PAGELENGTHS }         from 'g3w-constants';
import Component               from 'g3w-component';
import ApplicationState        from 'g3w-state';
import G3WField                from 'components/G3WField.vue';
import { toRawType }           from 'utils/toRawType';
import GUI                     from 'g3w-app';
import { debounce }            from 'utils/debounce';
import { getCatalogLayerById } from 'utils/getCatalogLayerById';
import { gettext as _ }        from 'g3w-i18n';

const __vue_script__ = {

  name: "G3WTable",

  components: {
    'g3w-field': G3WField,
  },

  data() {
    const layer    = getCatalogLayerById(this.$options.layerId);
    const headers  = layer.getTableHeaders();
    return {
      layer,
      state: {
        id:            layer.getId(),         // @since 4.1.0 aligned with query state layer
        selection:     layer.state.selection, // @since 4.1.0 aligned with query state layer
        filter:        layer.state.filter,    // @since 4.1.0 aligned with query state layer
        features:      [],
        headers,      
        geometry:      true,
        allfeatures:   0,
        geolayer: {
          active:    false,
          in_bbox:   undefined,
        },
      },
      // when the current layer is: alphanumerical + not child of relation + relation has geometry
      relations: (layer.isGeoLayer() ? [] : layer.getRelations().getArray())
        .map(relation => [relation, getCatalogLayerById(relation.getFather())])
        .filter(([relation, father]) => layer.getId() !== relation.getFather() && father.isGeoLayer())
        .map(([relation, father]) => ({
          layer:         father,
          father_fields: relation.getFatherField(), // NB: since g3w-admin@v3.7.0 this is an Array value.
          fields:        relation.getChildField(),  // NB: since g3w-admin@v3.7.0 this is an Array value.
          features:      {},
        })),
      filter:              [],
      has_map:             true,
      async_highlight:     () => {},
      disableSelectAll:    false,
      all:                 false,  // whehter all loaded features are selected
      PAGELENGTHS,
      ordering:            [0, 'asc'],
      search: {
        field:     undefined,
        page:      1,              // current page
        page_size: PAGELENGTHS[1],
        search:    null,
        in_bbox:   undefined,
        ordering:  headers?.[0]?.name,
        formatter: 1,
      },
    };
  },
  
  computed: {

    /**
     * @since 4.1.0
     */
    pages() {
      return Math.ceil(this.state.allfeatures / this.search.page_size);
    },
    current_layout() {
      return ApplicationState.layout[ApplicationState.layout.__current];
    },
  },

  watch: {
    async 'search.page_size'(length) {
      this.reload({ length });
    },
  },

  methods: {
    getFieldType(field) {
      let type = field.type;
      if ('vue' !== type) {
        const fieldValue = field.value;
        const value = fieldValue && 'Object' === toRawType(fieldValue) && !fieldValue.coordinates && !fieldValue.vue ? fieldValue.value : fieldValue;
        if (!value) {
          type = 'simple';
        } else if (value && 'object' === typeof value) {
          if (value.coordinates) {
            type = 'geo';
          } else if (value.vue) {
            type = 'vue';
          }
        } else if (value && Array.isArray(value)) {
          if (value.length && value[0].photo) {
            type = 'photo';
          } else {
            type = 'simple'
          }
        } else if (value.toString().toLowerCase().match(/^(https?:\/\/[^\s]+)\.(png|jpg|jpeg|gif)$/g)) {
          type = 'photo';
        } else if (value.toString().match(/^(https?:\/\/[^\s]+)/g)) {
          type = 'link';
        } else {
          type = 'simple';
        }
      }
      return `${type}_field`;
    },
    
    /**
     * @since 4.2.0 
     * @param action 
     * @param feature 
     */
    getFeatureActions(feature) {
      return ApplicationState.layersactions[this.layer.getId()]?.filter(a => a.condition?.({ layer: this.layer, feature }) ?? a.show ?? true);
    },
    
    /**
     * @since 4.2.0
     * @param action run Cbk action
     * @param feature 
     * @param action
     */
    runAction(action, feature) {
      action?.cbk?.(this.layer.state, feature, action);
    },
   

    /**
     * @param feature
     * 
     * @since 3.10.0
     */
     async openForm(layer, feature) {
      try {
        await GUI.getData('search:fids', {
          inputs: {
            layer:     this.layer,
            fids:      [feature.id],
            formatter: 1
          }
        });
        // zoom to feature
        if (feature.geometry) {
          GUI.zoomToExtent((new (Object.entries({
            'MultiPolygon': ol.geom.MultiPolygon,
            'MultiLine':    ol.geom.MultiLineString,
            'MultiPoint':   ol.geom.MultiPoint,
            'Polygon':      ol.geom.Polygon,
            'Line':         ol.geom.LineString,
            'Point':        ol.geom.Point,
            '':             ol.geom.Point, // fallback
          }).find(o => feature.geometry.type.startsWith(o[0])))[1](feature.geometry.coordinates))?.getExtent());
        }
      } catch(e) {
       console.warn(e); 
      }
    },

    /**
     * @param feature
     * 
     * @since 4.1.0
     */
    showRelations(layer, feature) {
      GUI.showRelations({ feature, layerId: layer.id, push: false });
    },

    /**
     * @since 4.1.0
     */
    showMetadata() {
      $('#modal-metadata').modal('show');
      setTimeout(() => document.querySelector('#modal-metadata [href="#metadata_layers"]').click());
    },

    async getDataFromBBOX() {
      this.state.geolayer.active = !this.state.geolayer.active;

      const is_active = this.state.geolayer.active;

      if (is_active) {
        this.onMoveEnd = () => {
          this.state.geolayer.in_bbox = this.state.geolayer.active ? GUI.getMapBBOX().join(',') : undefined;
          this.reload();
        };
      }

      if (is_active) {
        GUI.getMap().on('moveend', this.onMoveEnd);
      }

      this?.onMoveEnd?.();

      // reset bbox event handler
      if (!is_active) {
        GUI.getMap().un('moveend', this.onMoveEnd);
        this.onMoveEnd = null;
      }
    },

    /**
     * Highlight or zoom to feature
     * 
     * @param {*} feature
     * @param { boolean } zoom    - whether zoom to feature
     */
    async highlight(feature, zoom = true) {
      // no feature or no feature geometry → clear highlight
      if (!feature || !feature.geometry) {
        return GUI.highlight(false);
      }

      this.async_highlight = () => {
        GUI.highlight(false);
        GUI.highlight(feature.geometry, { zoom, duration: Infinity });
      };

      // sync highlight
      if (feature.geometry && this.has_map) {
        return this.async_highlight();
      }

      // skip when there is no relation features geometry
      if (feature.geometry || (!feature.geometry && !this.relations.length > 0)) {
        return;
      }

      // zoom and highlight relation features 
      const features     = [];
      const field_values = []; // check if add or not

      (await Promise.allSettled(this.relations.flatMap(({ layer, father_fields, fields }) => {
        const values = fields.map(f => feature.attributes[f]);
        field_values.push(values);
        return zoom
          ? GUI.getData('search:features', {
              inputs: {
                layer,
                formatter: 1,
                filter: father_fields.map((field, i) => `${field}|eq|${encodeURIComponent(values[i])}`).join('|AND,'),
              },
              outputs: false, // just a request not show on result
            })
          : [];
      })))
        .forEach((response, index) => {
          if ('fulfilled' === response.status) {
            const relation = this.relations[index];
            const k        = field_values[index].join('__'); // create a unique feature key
            const data     = response.value && response.value.data[0];
            if (undefined === relation.features[k]) {
              relation.features[k] = data && data.features || [];
            }
            features.push(...relation.features[k]);
          }
          if (zoom) {
            GUI.zoomToFeatures(features, { highlight: true });
          } else {
            let type, geometry;
            const coordinates = features
              .map(f => f.getGeometry ? f.getGeometry() : f.geometry)
              .map(geom => {
                type = type ? type : (geom instanceof ol.geom.Geometry) ? geom.getType() : geom.type;
                return geom?.getCoordinates?.() ?? geom.coordinates;
              });

            //check if features have geometry
            if (coordinates.length > 0) {
              try {
                geometry = new ol.geom[type.includes('Multi') ? type : `Multi${type}`](type.includes('Multi') ? coordinates.flat(): coordinates);
              } catch(e) {
                console.warn(e);
              }
            }
            GUI.highlight(geometry, { zoom: false });
          }
        });
    },

    /**
     * Add or Remove feature to selection
     */
    select(feature) {
      GUI.toggleSelection(this.state, feature);
    },

    /**
     * @param { number } index column index
     */
    sortColumn(index) {
      if (index === this.ordering[0]) {
        this.ordering[1] = 'asc' === this.ordering[1] ? 'desc' : 'asc';
      } else {
        this.ordering[0] = index;
        this.ordering[1] = 'asc';
      }
      this.reload({ ordering: index });
    },

    /**
     * @param {'all' | 'inverse' } status whether to select all/inverse features
     */
    async setSelection(status) {
      GUI.disableContent(true);
      GUI.setLoadingContent(true);
      try {        
        const features = [
          ...this.state.features,
          ...((await this.layer.getDataTable({ formatter: 1, field: this.search.field }))?.features || [])
            .filter(f => !this.state.features.find(({ id }) => id === f.id)).map(f => ({
              id:         f.id,
              selected:   this.layer.state.filter.active || this.all,
              attributes: f.attributes || f.properties,
              geometry:   f.geometry
            }))
        ]
        await GUI.toggleSelection({ ...this.state, features }, status);
        this.all = features.every(f => f.selected);
      } catch(e) {
        console.warn(e);
      }
      GUI.setLoadingContent(false);
      GUI.disableContent(false);
    },

    /**
     * Fetch data from server
     * 
     * @param { Object } opts
     * @param { number } opts.ordering
     * @param { number } opts.length
     * @param opts.columns
     * @param { string } opts.search
     * @param { number } opts.page current page
     */
    async getData({
      ordering  = 0,
      length    = this.layer.getAttributeTablePageLength() || PAGELENGTHS[1],
      columns   = {},
      search    = null,
      page      = 1,
    } = {}) {
      // no headers are set
      if (0 === this.state.headers.length) {
        return;
      }

      GUI.setLoadingContent(true);
      GUI.disableContent(true);

      this.layer.setAttributeTablePageLength(length);

      this.search = {
        field:      Object.entries(columns).length ? (Object.entries(columns).filter(([_, v]) => v).map(([i, v], index, arr) => `${this.state.headers[i].name}|ilike|${v}${index < arr.length - 1 ? '|AND' : ''}`).join(',') || undefined) : this.search.field,
        page,
        page_size: length,
        search:    (search ?? this.search.search) || undefined,
        in_bbox:   this.state.geolayer.in_bbox,
        ordering:  ('asc' === this.ordering[1] ? '' : '-') + this.state.headers[ordering].name,
        formatter: 1,
      };

      try {
        const data     = await this.layer.getDataTable(this.search);
        const features = (data.features || []).map(f => ({
          id:         f.id,
          selected:   this.layer.state.filter.active || this.layer.isSelected(f.id),
          attributes: f.attributes || f.properties,
          geometry:   f.geometry || undefined,
        }));

        this.state.allfeatures   = data.count;
        this.state.featurescount = (features || []).length;

        // reset features
        this.state.features.splice(0);
        this.state.features.push(...features);
        
        this.all = this.layer.state.filter.active || this.layer.state.selection.fids.has('__ALL__') || this.state.features.every(f => f.selected);
        
      } catch(e) {
        console.warn(e);
        GUI.showUserMessage({ type: 'alert', message: _("server_error") });
      }

      GUI.setLoadingContent(false);
      GUI.disableContent(false);
    },

    unSelectAll() {
      this.state.features.forEach(f => f.selected = false);
      this.state.selection.active  = false;
    },

    onGUIContent(opts = {}) {
      this.has_map = (100 !== opts.perc);
    },

    /**
     * Reload data from server
     * 
     * @since 4.1.0
     */
    async reload(opts = {}) {
      try {
        await this.getData(opts);
        this.disableSelectAll = 0 === this.state.features.length;
      } catch(e) {
        console.warn(e);
      } 
    },

  },

  async created() {
    this.unSelectAll  = this.unSelectAll.bind(this);
    this.onGUIContent = this.onGUIContent.bind(this)

    GUI.onbefore('setContent',         this.onGUIContent);
    this.layer.on('unselectionall',    this.unSelectAll);
    this.layer.on('filtertokenchange', this.reload);

    this.globalSearch = debounce(e => this.getData({ search: e.target.value }));

    GUI.closeSideBar();

    GUI.showContent({
      content: new Component({
        id:                'openattributetable',
        service:           { state: this.state },
        internalComponent: this,
      }),
      split: GUI.isMobile() ? 'h': 'v',
      push: false,
      title: this.layer.getTitle(),
      text:  true,
    });

    if (this.isMobile()) {
      GUI.hideSidebar();
    }
  },

  async mounted() {

    this.reload();

    //set layer actions for the current layer
    ApplicationState.layersactions[this.layer.getId()] = [
      {
        id :   "openform",
        cbk:   this.openForm.bind(this),
        hint:  "Form View",         
        class: "fas fa-table",
      },
      this.layer.hasRelations() ? {
        id:    "showreltions",
        cbk:   this.showRelations.bind(this),
        hint:  "Show Relations",         
        class: "fas fa-sitemap",
      }: {},
       {
        id:        "nogeometry",
        hint:      "This item has no geometry",         
        class:     "fa-exclamation-triangle",
        style:     "color: currentColor !important;",
        condition: ({ layer, feature } = {}) => layer.state.geolayer && !feature.geometry,
      }   
    ];

    //call setters
    GUI.addActionsForLayers(ApplicationState.layersactions, [ {
      id:       this.layer.getId(),
      features: this.state.features,
    }]);

    const columns = {}; // store columns index value search

    this.changeColumn = debounce(async (e, i) => {
      columns[i] = e.target.value.trim();
      this.getData({ columns });
    });

    // move "table_metadata", "table_info" and "table_search" before header action tools
    document.querySelector('#g3w-content .g3-content-header-action-tools').insertAdjacentElement('beforebegin', this.$refs['table_metadata']);
    document.querySelector('#g3w-content .g3-content-header-action-tools').insertAdjacentElement('beforebegin', this.$refs['table_info']);
    document.querySelector('#g3w-content .g3-content-header-action-tools').insertAdjacentElement('beforebegin', this.$refs['table_search']);
  },

  async beforeDestroy() {

    this.layer.off('unselectionall',    this.unSelectAll);
    this.layer.off('filtertokenchange', this.reload);

    // reset bbox event handler
    if (this.onMoveEnd) {
      GUI.getMap().un('moveend', this.onMoveEnd);
      this.onMoveEnd = null;
    }

    this.highlight();

    if (!this.has_map) {
      setTimeout(() => {
        this.async_highlight();
        this.has_map         = true;
        this.async_highlight = () => {};
      });
    }

    this.$refs['table_metadata'].remove();
    this.$refs['table_info'].remove();
    this.$refs['table_search'].remove();

    //reset layers actions
    ApplicationState.layersactions = {};
  },

};


/* template */
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"open_attribute_table"}},[_c('button',{ref:"table_metadata",staticClass:"btn btn-default",staticStyle:{"margin-right":"8px","font-size":"1.5rem","order":"-1"},attrs:{"type":"button","data-placement":"top","title":"Metadata"},on:{"click":_vm.showMetadata}},[_c('i',{staticClass:"fas fa-info-circle",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('span',{ref:"table_info",staticStyle:{"margin-left":".5ch"}},[_vm._v(_vm._s(_vm.state.allfeatures)+" "+_vm._s(_vm.$t('entries')))]),_vm._v(" "),_c('input',{ref:"table_search",staticClass:"form-control search",staticStyle:{"margin-left":"auto !important","margin-right":"1ch"},attrs:{"type":"search","placeholder":_vm.$t('dosearch')},on:{"keyup":_vm.globalSearch,"input":_vm.globalSearch}}),_vm._v(" "),(_vm.state.headers.length)?_c('table',{ref:"attribute_table",attrs:{"id":"layer_attribute_table"}},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"pointer-events":"none"}}),_vm._v(" "),_vm._l((_vm.state.headers),function(header,i){return _c('th',{class:[i === _vm.ordering[0] ? _vm.ordering[1] : '' ],style:({'width': `${100 / _vm.state.headers.length }%`}),attrs:{"title":_vm.$t('sort by:') + ' ' + header.name,"data-placement":"top"},on:{"click":function($event){$event.stopPropagation();return _vm.sortColumn(i)}}},[_vm._v(_vm._s(header.label))])})],2),_vm._v(" "),_c('tr',[_c('th',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.disableSelectAll),expression:"disableSelectAll"}]},[_c('label',{on:{"click":function($event){$event.stopPropagation();return _vm.setSelection('all')}}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.all}})])]),_vm._v(" "),_vm._l((_vm.state.headers),function(header,i){return _c('th',[_c('input',{staticClass:"form-control column-search",attrs:{"type":"text","placeholder":header.name,"title":_vm.$t('search by:') + ' ' + header.name,"data-placement":"bottom"},on:{"keyup":function($event){return _vm.changeColumn($event, i)}}})])})],2)]),_vm._v(" "),_c('tbody',{on:{"mouseleave":function($event){return _vm.highlight()}}},_vm._l((_vm.state.features),function(feature,i){return _c('tr',{key:feature.id,class:[
          i % 2 == 1 ? 'odd' : 'pair',
          'feature_attribute',
          { geometry: !!feature.geometry },
          { 'selected': feature.selected }
        ],on:{"mouseover":function($event){return _vm.highlight(feature, false)},"click":function($event){$event.stopPropagation();return _vm.highlight(feature, true)}}},[_c('td',[_c('div',{staticStyle:{"display":"flex"}},[(!_vm.layer.state.filter.active)?_c('label',{on:{"click":function($event){return _vm.select(feature)}}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":feature.selected}})]):_vm._e(),_vm._v(" "),_vm._l((_vm.getFeatureActions(feature)),function(action){return _c('i',{key:action.id,staticClass:"action-button skin-color",class:[action.class, { 'disabled': !!(action.state || {}).disabled }],style:(action.style),attrs:{"title":action.hint,"data-placement":"top"},on:{"click":function($event){$event.stopPropagation();return _vm.runAction(action, feature)}}})})],2)]),_vm._v(" "),_vm._l((_vm.state.headers),function(header){return _c('td',[_c('g3w-field',{attrs:{"field-type":_vm.getFieldType({ value: Array.isArray(feature.attributes[header.name]) ? feature.attributes[header.name].join(',') : feature.attributes[header.name] }),"feature":feature,"state":({ 
              label: undefined,
              //@since 4.1.0 support array value in attribute table https://github.com/g3w-suite/g3w-client-plugin-editing/issues/186
              value: Array.isArray(feature.attributes[header.name]) ? feature.attributes[header.name].join(',') : feature.attributes[header.name],
              name: header.name 
            })}})],1)})],2)}),0)]):_c('div',{directives:[{name:"t",rawName:"v-t",value:('No data'),expression:"'No data'"}],attrs:{"id":"noheaders"}}),_vm._v(" "),_c('div',{staticClass:"table-toolbar",staticStyle:{"display":"flex","gap":"1ch","margin-top":"1ch"}},[(_vm.layer.isGeoLayer())?_c('button',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.state.geolayer.active && _vm.current_layout.rightpanel.height_100),expression:"state.geolayer.active && current_layout.rightpanel.height_100"}],class:['btn', _vm.state.geolayer.active ? 'toggled' : '' ],attrs:{"title":"Update results when map moves","data-placement":"top"},on:{"click":function($event){$event.stopPropagation();return _vm.getDataFromBBOX.apply(null, arguments)}}},[_c('i',{staticClass:"far fa-map"})]):_vm._e(),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.layer.state.selection.active),expression:"layer.state.selection.active"}],staticClass:"btn",attrs:{"title":"Clear Selection","data-placement":"top"},on:{"click":function($event){$event.stopPropagation();return _vm.layer.clearSelectionFids()}}},[_c('i',{staticClass:"fas fa-broom"})]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.layer.state.filter.active && _vm.layer.state.selection.active),expression:"!layer.state.filter.active && layer.state.selection.active"}],class:[ 'btn', _vm.layer.state.filter.active ? 'g3w-disabled': '' ],attrs:{"title":"Invert Selection","data-placement":"top"},on:{"click":function($event){$event.stopPropagation();return _vm.setSelection('inverse')}}},[_c('i',{staticClass:"fas fa-exchange-alt"})]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.layer.state.selection.active && !_vm.layer.state.filter.pagination),expression:"layer.state.selection.active && !layer.state.filter.pagination"}],class:[ 'btn', _vm.layer.state.filter.active ? 'toggled' : '' ],attrs:{"title":"Enable/Disable filter","data-placement":"top"},on:{"click":function($event){$event.stopPropagation();return _vm.layer.toggleToken()}}},[_c('i',{staticClass:"fas fa-filter"})]),_vm._v(" "),_c('label',{staticStyle:{"margin-top":"5px"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.search.page_size),expression:"search.page_size"}],staticStyle:{"border":"1px solid #aaa"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.search, "page_size", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.PAGELENGTHS),function(l){return _c('option',{domProps:{"value":l}},[_vm._v(_vm._s(l))])}),0),_vm._v(" "+_vm._s(_vm.$t('values per page'))+"\n    ")]),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"auto"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.search.page),expression:"search.page"}],staticStyle:{"padding":"5px 12px","appearance":"none","border":"0","text-align":"center","border-radius":"3px","cursor":"pointer"},attrs:{"title":_vm.search.page + _vm.$t(' of ') + _vm.pages,"data-placement":"top"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.search, "page", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.pages),function(p){return _c('option',{domProps:{"selected":p == _vm.search.page}},[_vm._v(_vm._s(p))])}),0),_vm._v("\n      "+_vm._s(_vm.$t(' of ') + _vm.pages)+"\n      "),(_vm.pages > 1)?_c('button',{directives:[{name:"disabled",rawName:"v-disabled",value:(1 == _vm.search.page),expression:"1 == search.page"}],staticClass:"btn",attrs:{"title":"Backward","data-placement":"top"},on:{"click":function($event){$event.stopPropagation();_vm.reload({ page: Number(_vm.search.page) - 1 });}}},[_vm._v("🞀")]):_vm._e(),_vm._v(" "),(_vm.pages > 1)?_c('button',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.pages == _vm.search.page),expression:"pages == search.page"}],staticClass:"btn",attrs:{"title":"Forward","data-placement":"top"},on:{"click":function($event){$event.stopPropagation();_vm.reload({ page: Number(_vm.search.page) + 1 });}}},[_vm._v("🞂")]):_vm._e()])])])
}
var staticRenderFns = []

const __vue_render__ = render;
const __vue_staticRenderFns__ = staticRenderFns;

const __vue_component__ = __vue_script__;
__vue_component__.render = __vue_render__;
__vue_component__.staticRenderFns = __vue_staticRenderFns__;
__vue_component__._compiled = true;
__vue_component__.__file = "/home/volterra79/G3W-SUITE/g3w-client/src/components/Table.vue";
__vue_component__._scopeId = "data-v-65f98bf6";
/* style inject */
import __vue_create_injector__ from 'g3w-vue:style-injector';
[{"id":"65f98bf6-0","css":".geometry[data-v-65f98bf6]{cursor:pointer}#noheaders[data-v-65f98bf6]{background-color:#fff;font-weight:700;margin-top:10px}input.form-control.column-search[data-v-65f98bf6]::placeholder{font-weight:400;font-style:italic}input.form-control.column-search[data-v-65f98bf6]{height:25px;min-width:40px;padding:2px}#open_attribute_table[data-v-65f98bf6]{margin-top:5px}.action-button[data-v-65f98bf6]{padding:5px!important}button.toggled[data-v-65f98bf6]{color:#fff!important;background-color:var(--skin-color)}table[data-v-65f98bf6]{width:100%;user-select:none;display:block;height:calc(100% - 25px);overflow:auto;border-collapse:separate}thead[data-v-65f98bf6]{position:sticky;top:0;background-color:#fff}tbody>tr.selected[data-v-65f98bf6]{box-shadow:inset 0 0 0 9999px #0d6efde6;color:#fff}tbody>tr[data-v-65f98bf6]:not(.selected):hover{background-color:#ffff0026}th[data-v-65f98bf6],td[data-v-65f98bf6]{white-space:nowrap}th[data-v-65f98bf6]{cursor:pointer}td[data-v-65f98bf6]{border-top:1px solid rgba(0,0,0,.15)}th.asc[data-v-65f98bf6],th.desc[data-v-65f98bf6]{border-top:var(--skin-color) medium solid}th.asc[data-v-65f98bf6]:after{content:\"\\25b4\"}th.desc[data-v-65f98bf6]:after{content:\"\\25be\"}\n","media":"","filename":"src/components/Table.vue"}].forEach(__vue_create_injector__());
export default __vue_component__;